import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { ShareCertificateComponent } from './share-certificate.component';
import { ShareComponent } from './share/share.component';

@NgModule({
	imports: [CommonModule, FormsModule, IonicModule, ScrollingModule],
	declarations: [ShareCertificateComponent, ShareComponent],
	exports: [ShareCertificateComponent],
})
export class ShareCertificateModule {}
